import { createSelector } from '@reduxjs/toolkit';
import { getGlobalDepartments } from 'utils/personnelHelper';

import { getGlobalDepartmentRecords } from 'selectors/globalSelectors';
import { transform } from 'utils/DataTransform/Zone/zoneList';
import { selectors as dataGridTableSelectors } from '../Modules/dataGridTable';
import { selectors as filtersSelectors } from '../Modules/filters';
import { zoneDetailsTransform } from 'utils/DataTransform/Zone/zoneDetails';

// gets transformed zone list
export const getZoneListTransformed = createSelector(
  dataGridTableSelectors.getGridTableList,
  getGlobalDepartmentRecords,
  (zoneList, globalDepartmentRecords) => {
    if (!zoneList) {
      return [];
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);

    const transformedList = transform(zoneList, globalDepartmentList);
    return transformedList;
  },
);

// gets raw zoneList without any transform
export const getZoneListRaw = createSelector(
  dataGridTableSelectors.getGridTableList,
  zoneList => {
    if (!zoneList) {
      return [];
    }

    return zoneList;
  },
);

// total rowCount of zoneList
export const getTotalRowsCount = createSelector(
  dataGridTableSelectors.getTotalGridRows,
  rowsCount => rowsCount,
);
// status of list refresh
export const getForceRefresh = createSelector(
  dataGridTableSelectors.getForceRefresh,
  forceRefresh => forceRefresh,
);

// zone filters
export const getZoneFilters = createSelector(
  filtersSelectors.getFilterValues,
  filterValues => {
    return filterValues;
  },
);

// if the filter key is pressed this value is set to true otherwise false
export const getZoneFilterKey = createSelector(
  filtersSelectors.getFilterKey,
  filterKey => filterKey,
);

// gets the rowID of the selected zone row
export const getSelectedRowID = createSelector(
  dataGridTableSelectors.getSelectedRowID,
  selectedRowID => selectedRowID,
);

// gets the transformedZoneDetails
export const getZoneDetailsTransformed = createSelector(
  dataGridTableSelectors.getGridRowDetails,
  getGlobalDepartmentRecords,
  (details, globalDepartmentRecords) => {
    if (!details) {
      return {};
    }
    // convert it into id and name list array
    const globalDepartmentList = getGlobalDepartments(globalDepartmentRecords);
    const transformedDetails = zoneDetailsTransform(
      details,
      globalDepartmentList,
    );
    return transformedDetails;
  },
);
